import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { appConfig } from "../../environments/app.config";

@Component({
  selector: 'app-header',
  imports: [
    CommonModule, 
    MatToolbarModule, 
    RouterModule, 
    MatIcon, 
    MatMenuModule, 
    MatButtonModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  public isNavbarOpen = false;
  public factoryLogo: string = appConfig.factoryLogo; // factory Logo
  public navLinks!: { label: string ,route: string }[]

  constructor(){}

  ngOnInit(): void {
    this.headerModules()
  }

  private headerModules(): void {

    this.navLinks = [
      { label: "HOME", route: "/home" },
      { label: "ABOUT US", route: "/about-us" },
      { label: "PRODUCTS", route: "/product" },
      { label: "SERVICES", route: "/service" },
      { label: "PROTOTYPING", route: "/prototype" },
      { label: "CLIENTS", route: "/client" },
      { label: "CONTACT US", route: "/contact-us" },
    ];

  }

  public toggleNavbar(): void {
    this.isNavbarOpen = !this.isNavbarOpen;
  }

}
